import { z } from 'zod';
import * as Sentry from '@sentry/react';

export function defaultZodErrorHandler(error: z.ZodError, item: unknown) {
  if (process.env.NODE_ENV === 'development') {
    console.error('Validation failed for item', item, error);
  }
  Sentry.captureException(error);
}

/**
 * Validates each element of an array against a Zod schema using .parse().
 * Elements that fail validation are omitted from the result.
 *
 * @param schema - Zod schema to validate each element
 * @param arr - Array of unknown values to validate
 */
export function parseArrayFilterInvalid<T>(
  schema: z.ZodType<T>,
  arr: unknown,
  onError: (error: z.ZodError, item: unknown) => void = defaultZodErrorHandler
): T[] {
  const result: T[] = [];
  if (!Array.isArray(arr)) {
    const error = new z.ZodError([{ message: 'Input is not an array', code: 'custom', path: [] }]);
    onError(error, arr);
    return [];
  }
  for (const item of arr) {
    try {
      result.push(schema.parse(item));
    } catch (error) {
      if (error instanceof z.ZodError) {
        onError(error, item);
        continue;
      }
      throw error;
    }
  }
  return result;
}
